import axios from "axios";
import interceptor from "./petition_interceptor";

export default function path_user(key, valone, valtwo) {
  const json = require("../../../../config.json");
  const urlBase = json.urlBase;
  const token = JSON.parse(localStorage.getItem("persist:demo4-auth"));
  var url;
  var data;
  // var urlBase = "http://api.itpscorp.com/dev/crmui";
  // var urlBase = "https://api.itpscorp.com/crmui"
  // if (token.authToken) {
  switch (key) {
    case "vault-credential":
      // valone is credential id, valtwo is the partial update
      url = urlBase + "/asset-tracking/credentials/" + valone;
      data = valtwo;
      break;
    case "profile":
      url = urlBase + "/profile";
      // url = "http://api.itpscorp.com/dev/crmui/profile";
      data = valone;
      break;

    case "updatecc":
      url = urlBase + "/accounts/" + valone;
      // url = "http://api.itpscorp.com/dev/crmui/accounts/"+valone+"/credit-card";
      data = valtwo;
      console.log(valtwo);
      break;
    case "asterikQueues":
      url = urlBase + "/itpvoice/queue-servers/" + valone;
      data = valtwo;
      break;
    case "editaccount":
      console.log(valtwo);
      url = urlBase + "/accounts/" + valone;
      // url = "http://api.itpscorp.com/dev/crmui/accounts/"+valone;
      data = {
        // pk: 211,
        name: valtwo.name,
        phone: valtwo.phone,
        website: valtwo.website,
        billing_address: valtwo.billing_address,
        billing_city: valtwo.billing_city,
        billing_state: valtwo.billing_state,
        billing_zipcode: valtwo.billing_zipcode,
        billing_country: valtwo.billing_country,
        billing_address_suite: valtwo.billing_address_suite,
        po_number: valtwo.po_number,
        industry: valtwo.industry,
        // accountnumber: 45782022,
        status: valtwo.status,
        net_terms: valtwo.net_terms,
        // imgurl: null,
        // billing_api_id: 4a8c86f882294c4eb80c8ffeb229d908,
        account_type: valtwo.account_type,
        // account_type: "residential",
        agent_id: valtwo.agent_id,
        billing_cycle_month_date: valtwo.billing_cycle_month_date,
        ebilling: valtwo.ebilling,
        automatic_payments: valtwo.automatic_payments,
        tax_exempt: valtwo.tax_exempt,
        // ITP or Knack; only sent when the page set it (API: admins only)
        ...(valtwo.billing_brand ? { billing_brand: valtwo.billing_brand } : {}),
        // N-able RMM integration
        nable_client_id: valtwo.nable_client_id,
        // Workbench folder mapping (-> /workspace/customers/<folder>)
        workspace_folder: valtwo.workspace_folder,
      };
      break;
    case "editContacts":
      url = urlBase + "/contacts/" + valone;
      // url = "http://api.itpscorp.com/dev/crmui/profile";
      data = valtwo;
      break;
    case "updateService":
      url = urlBase + "/services/" + valone;
      // url = "http://api.itpscorp.com/dev/crmui/profile";
      data = valtwo;
      break;
    case "services":
      url = urlBase + "/services/" + valone;
      data = valtwo;
      break;

    case "quoteitemsService":
      url = urlBase + "/quoteitems/" + valone;
      // url = "http://api.itpscorp.com/dev/crmui/profile";
      console.log(url);
      data = valtwo;
      break;
    case "calendar":
      url = urlBase + "/calendar/" + valone;
      data = valtwo;
      break;

    case "changeQuoteService":
      url = urlBase + "/quoteitems/" + valone;
      // url = "http://api.itpscorp.com/dev/crmui/profile";
      console.log(valtwo);
      data = valtwo;
      break;

    case "service-address":
      url = urlBase + "/service-address/" + valone;
      // url = "http://api.itpscorp.com/dev/crmui/profile";
      data = valtwo;
      break;
    case "service-address-edit":
      url = urlBase + "/services/" + valone;
      // url = "http://api.itpscorp.com/dev/crmui/profile";
      data = valtwo;
      break;
    case "products":
      console.log("dadsads");
      url = urlBase + "/products/" + valone;
      // url = "http://api.itpscorp.com/dev/crmui/profile";
      data = valtwo;
      break;
    case "tickets":
      url = urlBase + "/tickets/" + valone;
      // url = "http://api.itpscorp.com/dev/crmui/profile";
      data = valtwo;
      break;
    case "ticket-management/tickets":
      url = urlBase + "/ticket-management/tickets/" + valone;
      data = valtwo;
      break;
    case "agents":
      url = urlBase + "/agents/" + valone;
      // url = "http://api.itpscorp.com/dev/crmui/profile";
      data = valtwo;
      break;
    case "users":
      url = urlBase + "/users/" + valone;
      // url = "http://api.itpscorp.com/dev/crmui/profile";
      data = valtwo;
      break;
    case "contract-signing-settings":
      // PATCH one contract type's counter-signature configuration.
      // valone is the body: {contract_type, countersign_required, default_signer_id}
      url = urlBase + "/settings/contract-signing";
      data = valone;
      break;
    case "quotes":
      url = urlBase + "/quotes/" + valone;
      // url = "http://api.itpscorp.com/dev/crmui/profile";
      data = valtwo;
      break;
    case "orderitems":
      url = urlBase + "/orderitems/" + valone;
      // url = "http://api.itpscorp.com/dev/crmui/profile";
      data = valtwo;
      break;
    case "leads":
      url = urlBase + "/leads/" + valone;
      // url = "http://api.itpscorp.com/dev/crmui/profile";
      data = valtwo;
      break;
    case "leadsources":
      url = urlBase + "/leadsources/" + valone;
      data = valtwo;
      break;
    case "system-api-keys":
      // PATCH /system-api-keys/{id} - name/description/scopes/expires_at
      url = urlBase + "/system-api-keys/" + valone;
      data = valtwo;
      break;
    case "lead_contacts":
      url = urlBase + "/leads/" + valone;
      data = valtwo;
      break;
    case "lead_notes":
      // valone is the path suffix, e.g. "/leads/123/notes/456"
      url = urlBase + valone;
      data = valtwo;
      break;
    case "bids":
      url = urlBase + "/bids/" + valone;
      data = valtwo;
      break;
    case "bid_files":
      // valone is the path suffix, e.g. "/bids/123/files/456"; valtwo = { description, file_name? }
      url = urlBase + valone;
      data = valtwo;
      break;
    case "carriers":
      url = urlBase + "/sbc/carriers/" + valone;
      // url = "http://api.itpscorp.com/dev/crmui/profile";
      data = valtwo;
      break;
    case "carrierIPS":
      url = urlBase + "/sbc/carrier-ips/" + valone;
      // url = "http://api.itpscorp.com/dev/crmui/profile";
      data = valtwo;
      break;
    case "dids":
      url = urlBase + "/sbc/dids/" + valone;
      // url = "http://api.itpscorp.com/dev/crmui/profile";
      data = valtwo;
      break;
    case "rates":
      url = urlBase + "/sbc/rates/" + valone;
      // url = "http://api.itpscorp.com/dev/crmui/profile";
      data = valtwo;
      break;
    case "internationalRates":
      url = urlBase + "/sbc/international-rates/" + valone;
      // url = "http://api.itpscorp.com/dev/crmui/profile";
      data = valtwo;
      break;

    case "customerIps":
      url = urlBase + "/sbc/customer-ips/" + valone;
      // url = "http://api.itpscorp.com/dev/crmui/profile";
      data = valtwo;
      break;
    case "carrierDestinations":
      url = urlBase + "/sbc/carrier-destinations/" + valone;
      // url = "http://api.itpscorp.com/dev/crmui/profile";
      data = valtwo;
      break;
    case "didDestinationGroups":
      url = urlBase + "/sbc/did-destination-groups/" + valone;
      // url = "http://api.itpscorp.com/dev/crmui/profile";
      data = valtwo;
      break;
    case "statusEvent":
      url = urlBase + "/ticket-events/" + valone;
      // url = "http://api.itpscorp.com/dev/crmui/profile";
      data = valtwo;
      break;
    case "ticket-blacklist":
      url = urlBase + "/ticket-blacklist/" + valone;
      // url = "http://api.itpscorp.com/dev/crmui/profile";
      data = valtwo;
      break;
    case "agenPayaouts":
      url = urlBase + "/agentpayouts/" + valone;
      // url = "http://api.itpscorp.com/dev/crmui/profile";
      data = valtwo;
      break;
    case "serviceAddons":
      url = urlBase + "/service-addons/" + valone;
      // url = "http://api.itpscorp.com/dev/crmui/profile";
      data = valtwo;
      break;
    case "ITPVoice":
      // console.log(value);
      url = urlBase + "/itpvoice/app-store/" + valone;
      data = valtwo;
      break;
    case "appPage":
      // console.log(value);
      url = urlBase + "/itpvoice/apps/" + valone.pk + "/pages/" + valone.pkPage;
      data = valtwo;
      break;
    case "changeAddressService":
      // console.log(value);
      url = urlBase + "/services/" + valone.pk;
      data = valtwo;
      break;
    case "assets":
      // console.log(value);
      url = urlBase + "/asset-tracking" + valone;
      data = valtwo;
      break;
    case "network-locations":
      url = urlBase + valone;
      data = valtwo;
      break;
    case "equipment-locations":
      url = urlBase + valone;
      data = valtwo;
      break;
    case "network-devices":
      url = urlBase + valone;
      data = valtwo;
      break;
    case "network-connections":
      url = urlBase + valone;
      data = valtwo;
      break;
    case "audit-logs":
      url = urlBase + valone;
      data = valtwo;
      break;
    case "customer-profile":
      url = urlBase + "/accounts/" + valone + "/customer-profile";
      data = valtwo;
      break;
    case "settings/account":
      url = urlBase + "/settings/account";
      data = valone;
      break;
    case "accounts":
      url = urlBase + "/accounts/" + valone;
      data = valtwo;
      break;
    case "kong":
      url = urlBase + "/kong" + valone;
      data = valtwo;
      break;
    case "saas-products":
      url = urlBase + "/saas-products/" + valone;
      data = valtwo;
      break;
    case "infrastructure-credentials":
      // valone is the path suffix after /infrastructure/, e.g. "42/credentials/9"
      url = urlBase + "/infrastructure/" + valone;
      data = valtwo;
      break;
    case "projects":
      url = urlBase + "/projects/" + valone;
      data = valtwo;
      break;
    case "standalone-tasks":
      url = urlBase + "/tasks/" + valone;
      data = valtwo;
      break;
    case "task-comments":
      url = urlBase + "/" + valone;
      data = valtwo;
      break;
    case "share-links":
      url = urlBase + "/share-links/" + valone;
      data = valtwo;
      break;
    case "project-invites":
      url = urlBase + "/project-invites/" + valone;
      data = valtwo;
      break;
    case "scheduled-reminders":
      // PATCH /scheduled-reminders/{id} - Update a scheduled reminder
      url = urlBase + "/scheduled-reminders/" + valone;
      data = valtwo;
      break;
    case "expenses":
      // PATCH /expenses/{id} - Update a draft expense
      url = urlBase + "/expenses/" + valone;
      data = valtwo;
      break;
    case "master-vendors":
      url = urlBase + "/master-vendors/" + valone;
      data = valtwo;
      break;
    case "ipam-addresses":
      // PATCH /ipam/addresses/{id} - Update address (assign/reserve/release)
      url = urlBase + "/ipam/addresses/" + valone;
      data = valtwo;
      break;
    case "ipam-blocks":
      // PATCH /ipam/blocks/{id} - Update block (assign/reserve/release)
      url = urlBase + "/ipam/blocks/" + valone;
      data = valtwo;
      break;
    case "ipam-pools":
      // PATCH /ipam/pools/{id} - Update pool metadata
      url = urlBase + "/ipam/pools/" + valone;
      data = valtwo;
      break;
    case "deploy/servers":
      // PATCH /settings/deploy/servers/{id} - Update deploy server
      url = urlBase + "/settings/deploy/servers/" + valone;
      data = valtwo;
      break;
    case "personal-vault":
      // PATCH /personal-vault/credentials/{id} - Update personal vault credential
      url = urlBase + "/personal-vault" + valone;
      data = valtwo;
      break;

    // =========================================================================
    // M365 Security (Admin Tools)
    // =========================================================================
    case "m365-tenant":
      // PATCH /accounts/{account_id}/m365/tenant - Update tenant config
      // Call pattern: petition_patch("m365-tenant", account_id, payload)
      url = urlBase + "/accounts/" + valone + "/m365/tenant";
      data = valtwo;
      break;
    case "m365-finding":
      // PATCH /accounts/{account_id}/m365/findings/{finding_id} - Ack/suppress/resolve
      // Call pattern: petition_patch("m365-finding", account_id, { finding_id, status, note })
      url = urlBase + "/accounts/" + valone + "/m365/findings/" + valtwo.finding_id;
      data = { status: valtwo.status, note: valtwo.note };
      break;
    case "m365-global-settings":
      // PATCH /m365/global-settings - Toggle enabled / set default interval
      // Call pattern: petition_patch("m365-global-settings", null, payload)
      url = urlBase + "/m365/global-settings";
      data = valtwo;
      break;

    // =========================================================================
    // Google Workspace (Admin Tools)
    // =========================================================================
    case "gw-tenant":
      // PATCH /accounts/{account_id}/google-workspace/tenant - Update tenant config
      // Call pattern: petition_patch("gw-tenant", account_id, payload)
      url = urlBase + "/accounts/" + valone + "/google-workspace/tenant";
      data = valtwo;
      break;
    case "gw-global-settings":
      // PATCH /google_workspace/global-settings - Upload shared SA / toggle enabled
      // Call pattern: petition_patch("gw-global-settings", null, payload)
      url = urlBase + "/google_workspace/global-settings";
      data = valtwo;
      break;
    case "service-voice-internals":
      // PATCH /services/{service_id}/voice-internals - admin raw editor for asterisk-api account row
      // Call pattern: petition_patch("service-voice-internals", service_id, { field: newValue, ... })
      url = urlBase + "/services/" + valone + "/voice-internals";
      data = valtwo;
      break;
    case "appriver-global-config":
      // PATCH /appriver/global-config - update partner credentials / toggle enabled
      // Call pattern: petition_patch("appriver-global-config", null, payload)
      url = urlBase + "/appriver/global-config";
      data = valtwo;
      break;
    case "whatsapp-instance":
      // valone is the instance id, valtwo the partial update
      url = urlBase + "/whatsapp/instances/" + valone;
      data = valtwo;
      break;
    case "whatsapp-allowlist":
      // valone is the allowlist entry id, valtwo the partial update
      url = urlBase + "/whatsapp/allowlist/" + valone;
      data = valtwo;
      break;
    case "vitelity-global-config":
      // PATCH /vitelity/global-config - update login/password / toggle enabled
      // Call pattern: petition_patch("vitelity-global-config", null, payload)
      url = urlBase + "/vitelity/global-config";
      data = valtwo;
      break;
    case "vpn-peer":
      // PATCH /accounts/{account_id}/vpn/peers/{peer_id} - Update a Managed VPN peer
      // Call pattern: petition_patch("vpn-peer", account_id, { peer_id, payload })
      url = urlBase + "/accounts/" + valone + "/vpn/peers/" + valtwo.peer_id;
      data = valtwo.payload;
      break;
    case "itppdf-license":
      // PATCH /itppdf/licenses/{license_id} - Update an ITP PDF key's label and/or seats
      // Call pattern: petition_patch("itppdf-license", license_id, { note?, seats? })
      url = urlBase + "/itppdf/licenses/" + valone;
      data = valtwo;
      break;

    default:
      return "error";
      break;
  }
  var config = {
    headers: {
      Authorization: "Bearer " + token.authToken.replace(/['"]+/g, ""),
    },
  };

  return interceptor.patch(url, data);
  // } else {
  //   window.location.href = "./Dashboard";
  // }
}
